import React from 'react'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import AttributesFeature from '../../features/AttributesFeature'
import { Box } from '@mui/material'

const Page = (): JSX.Element => {
  return (
    <React.Fragment>
      <Box display='flex' flexDirection='column' gap={6}>
        <CustomHeader title={PAGE_TITLES.ATTRIBUTES} />
        <AttributesFeature />
      </Box>
    </React.Fragment >
  )
}

export default Page
